import APIAMemberInformation from "../../APIA/APIAMemberInformation/APIAMemberInformation";
import ARIMemberInformation from "../../ARI/ARIMemberInformation/ARIMemberInformation";
import ATFMemberInformation from "../../ATF/ATFMemberInformation/ATFMemberInformation";
import { BMOMemberInformation } from "../../BMO/BMOMemberInformation/Index";
import BWCMemberInformation from "../../BWC/BWCMemberInformation/BWCMemberInformation";
import { CGWMemberInformation } from "../../CGW/CGWMemberInformation/Index";
import CIBCMemberInformation from "../../CIBC/CIBCMemberInformation/CIBCMemberInformation";
import CRRMemberInformation from "../../CRR/CRRMemberInformation/CRRMemberInformation";
import { DHMemberInformation } from "../../D&H/DHMemberInformation";
import { DAAMemberInformation } from "../../DAA/DAAMemberInfomation";
import ECCMemberInformation from "../../ECC/ECCMemberInformation/ECCMemberInformation";
import FIMCMemberInformation from "../../FIMC/FIMCMemberInformation/FIMCMemberInformation";
import GMIMemberInformation from "../../GMI/GMIMemberInformation/GMIMemberInformation";
import { ContractInformation } from "../../LDS/ContractInformation";
import NFIMemberInformation from "../../NFI/NFIMemberInformation/NFIMemberInformation";
import { R66MemberInformation } from "../../R66/R66MemberInformation/Index";
import PolicyInformation from "../../TVL/PolicyInformation/PolicyInformation";
import { JPLMemberInformation } from "../../JPL/JPLMemberInformation";
import { GSTMemberInformation } from "../../GST/GSTMemberInformation";
import { ATTMemberInformation } from "../../ATT/ATTMemberInformation";
import { CARPMemberInformation } from "../../CARP/CARPMemberInformation";
import { TDMemberInformation } from "../../TD/TDMemberInformation";
import { APEXMemberInformation } from "../../APEX/APEXMemberInformation";
import { PGMemberInformation } from "../../PG/PGMemberInformation";
import { CARSMemberInformation } from "../../CARS/CARSMemberInformation";
import { MMCMemberInformation } from "../../MMC/MMCMemberInformation";
import { EFGMemberInformation } from "../../EFG/EFGMemberInformation";
import { APAMemberInformation } from "../../APA/APAMemberInformation";
import { MJMCMemberInformation } from "../../MJMC/MJMCMemberInformation";
import { CREMemberInformation } from "../../CRE/CREMemberInformation";
import { DRIVOMemberInformation } from "../../DRIVO/DRIVOMemberInformation";
import { MERMemberInformation } from "../../MER/MERMemberInformation";
import { CYSUMemberInformation } from "../../CYSU/CYSUMemberInformation";
import { GKWMemberInformation } from "../../GKW/GKWMemberInformation";
import APCOMemberInformation from "../../APCO/APCOMemberInformation";

function GenericMemberInformation(props) {
  const partner = props.partner;
  const state = props.currState;
  const isPortalUser = props.currState.isPortalUser;
  return (
    <>
      {/* Contract Information Portal */}
      {(partner === "APIA" ||
        partner === "ESTRA" ||
        partner === "CH" ||
        partner === "CIA" ||
        partner === "OGIA" ||
        partner === "MLI" ||
        partner === "LIS" ||
        partner === "DCAP" ||
        partner === "JIC" ||
        partner === "TIM" ||
        partner === "CP" ||
        isPortalUser) && (
        <APIAMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information Holman */}
      {(partner === "ARIU" || partner === "ARIC") && (
        <ARIMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          onUserCancel={props.onUserCancel}
          backButtonFunc={props.backButtonFunc}
        />
      )}

      {/* Contract Information APA */}
      {partner === "APA" && (
        <APAMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information APEX */}
      {partner === "APEX" && (
        <APEXMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information APCO */}
      {partner === "APCO" && (
        <APCOMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information ATF */}
      {partner === "ATF" && (
        <ATFMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information ATT */}
      {partner === "ATT" && (
        <ATTMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information BMO */}
      {partner === "BMO" && (
        <BMOMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information BWC */}
      {partner === "BWC" && (
        <BWCMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CARS */}
      {partner === "CARS" && (
        <CARSMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CGW */}
      {partner === "CARP" && (
        <CARPMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CGW */}
      {partner === "CGW" && (
        <CGWMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CIBC*/}
      {(partner === "CIBC" || partner === "LMC") && (
        <CIBCMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CRE */}
      {partner === "CRE" && (
        <CREMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CRR */}
      {partner === "CRR" && (
        <CRRMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information CYSU */}
      {partner === "CYSU" && (
        <CYSUMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information DAA */}
      {partner === "DAA" && (
        <DAAMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information D&H */}
      {partner === "DH" && (
        <DHMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information DRIVO */}
      {partner === "DRIVO" && (
        <DRIVOMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information ECC*/}
      {partner === "ECC" && (
        <ECCMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
          phoneNumber={props.phoneNumber}
        />
      )}

      {/* Contract Information EFG*/}
      {partner === "EFG" && (
        <EFGMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
          phoneNumber={props.phoneNumber}
        />
      )}

      {/* Contract Information GKW */}
      {partner === "GKW" && (
        <GKWMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information JPL*/}
      {(partner === "JPLU" || partner === "JPLC") && (
        <JPLMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
          phoneNumber={props.phoneNumber}
        />
      )}

      {/* Contract Information FIMC */}
      {partner === "FIMC" && (
        <FIMCMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information GMI */}
      {partner === "GMI" && (
        <GMIMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information GST */}
      {partner === "GST" && (
        <GSTMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information LDS */}
      {partner === "LDS" && (
        <ContractInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information MER */}
      {partner === "MER" && (
        <MERMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information MJMC */}
      {partner === "MJMC" && (
        <MJMCMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information MMC */}
      {(partner === "MMC" || partner === "BTRIN") && (
        <MMCMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information NFI */}
      {partner === "NFI" && (
        <NFIMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information PG */}
      {partner === "PG" && (
        <PGMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Information Route 66 */}
      {partner === "R66" && (
        <R66MemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Policy Information TD */}
      {partner === "TD" && (
        <TDMemberInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Policy Information TVL */}
      {partner === "TVL" && (
        <PolicyInformation
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          callBackFunc={props.callBackFunc}
          backButtonFunc={props.backButtonFunc}
          onUserCancel={props.onUserCancel}
        />
      )}
    </>
  );
}

export default GenericMemberInformation;
